import { atom,  } from "recoil";

export const listEmployeesAtom = atom({
  key: "listEmployeesAtom",
  default: [],
});
